import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { BlockButtonComponent } from './block-button.component';
import { ButtonModule } from '@app/components/button/button.module';

@NgModule({
  imports: [CommonModule, SharedModule, ButtonModule],
  declarations: [BlockButtonComponent],
  exports: [BlockButtonComponent],
})
export class BlockButtonModule {}
